
import { Injectable } from '@angular/core';
import { MemberService } from './member.service';
import { AngularFirestore } from 'angularfire2/firestore';

// services
import { DBContextFirebaseService } from '../db-context/db-context.firebase.service';
import { User } from 'app/core/user';
import { Chat } from 'app/interfaces/global.interface';


interface PatientCalCount {
    userUid: string;
    educatorVisitCount: number;
}

@Injectable()
export class MemberFirebaseService implements MemberService {



    constructor(
        private afDB: AngularFirestore,
        private dBContextFirebaseService: DBContextFirebaseService
    ) { }

    // Post Login
    async getUserMembers(user: User): Promise<User[]> {

        const collection = this.afDB.firestore.collection('users')

        let query;

        if (user.roles.user_viewAllPatients) {
            query = collection.where('userType', '==', 'member')
        } else if (user.userType === 'doctor') {
            query = collection.where('doctorId', '==', user.uid)
        } else if (user.userType === 'educator') {
            query = collection.where('educatorUid', '==', user.uid)
        }

        let users = <User[]>await (this.dBContextFirebaseService.getCollection(query));

        if (!user.roles.user_viewAllPatients) {
            users = users.filter(x => x.membership === 'gold')
        }

        console.log('before exit ' + user.firstName, users)
        return users
    }

    async getUserMemberDEducatorCalendars(users: User[]): Promise<PatientCalCount[]> {

        const UsersEductorCalendars: PatientCalCount[] = [];
        if (users) {
            for (let index = 0; index < users.length; index++) {
                const user = users[index];

                const collection = this.afDB.firestore.collection('users')
                    .where('consultationType', '==', 'diabetesEducatorConsultation')

                const userCals = await this.dBContextFirebaseService.getCollection(collection)

                const calObj: PatientCalCount = {
                    userUid: user.uid,
                    educatorVisitCount: userCals.length
                }
                UsersEductorCalendars.push(calObj)
            }
            return UsersEductorCalendars;
        }
        return UsersEductorCalendars;
    }

    async setMember(member: User): Promise<User[]> {

        const collection = this.afDB.collection('users/')
        return this.dBContextFirebaseService.set(member, collection)
    }


    // Chat
    async setChatMessage(data: Chat): Promise<Chat> {
        const collection = this.afDB.collection('users/' + data.memberUid + '/chat')
        return this.dBContextFirebaseService.set(data, collection)
    }
}
